var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgCheckSolid = function SvgCheckSolid(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Solid Check' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 24C1 11.318375 11.318375 1 24 1s23 10.318375 23 23-10.318375 23-23 23S1 36.681625 1 24zm20.980957 4.2558594l-7.7418213-7.0596924L12 23.5592041l9.980957 9.6016846 15.2832032-16.4852295L34.9130859 14 21.980957 28.2558594z",
    fill: props.fill
  }));
};
SvgCheckSolid = pure(SvgCheckSolid);
SvgCheckSolid.displayName = 'SvgCheckSolid';
export default SvgCheckSolid;